import React, { useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import moment from "moment-timezone";
import { Icon, DataTable, Modal } from '../../widgets';
import { usePermission } from '../../../helpers/common';
import UserForm from '../Common/UserForm';
import { deleteUser } from '../../../actions/users';
import AssignFarmModal from './AssignFarmModal';
import AccessFormModal from './AccessFormModal';
import PermissionFormModal from './PermissionFormModal';
import { QAPP_ROLE_ID, NOT_APPLICABLE } from '../../../constants';
import LoadingStyle from '../Common/LoadingStyle';
import { dateUTCToTimezone, toDisplayDateTimeString } from '../../../helpers/moment-ex';
import AssignCustomerModal from './AssignCustomerModal';
import AssignOEMModal from './AssignOEMModal';

const UserItem = props => {
    const { index, userInfo, providerListById, isRequestingAuthList, timezone, isCustomerList } = props;

    const [showModal, setShowModal] = useState({ edit: false, delete: false, assignFarm: false, access: false, permission: false, assignCustomer: false, assignOEM: false });
    const [currentAuthId, setCurrentAuthId] = useState(null);

    const handleModal = (type, isShow) => setShowModal({ ...showModal, [type]: isShow });

    const handleAccessModal = (type, isShow, id) => {
        handleModal(type, isShow);
        setCurrentAuthId(parseInt(id));
    };

    const handleDeleteConfim = () => props.actions.deleteUser(userInfo.user_id);

    const allow = usePermission();
    const isAllowEdit = allow("user", "edit") ? true : false;
    const isAllowDelete = allow("user", "delete") ? true : false;
    const isAllowAction = isAllowEdit || isAllowDelete;
    const isActive = showModal.edit || showModal.delete || showModal.assignFarm || showModal.access || showModal.permission;

    const getStatus = () => {
        if (userInfo.status_id === 1)
            return <span className="badge badge-pill badge-success badge-sm" style={{ fontWeight: 400 }}>active</span>;
        else if (userInfo.status_id === 2)
            return <span className="badge badge-pill badge-danger badge-sm" style={{ fontWeight: 400 }}>locked</span>;
        else return NOT_APPLICABLE;
    };

    const getSortedAuthList = list => {
        const sortedAuthList = [...list];
        sortedAuthList.length > 0 && sortedAuthList.sort((a, b) => a.authentication_provider_id - b.authentication_provider_id);
        return sortedAuthList;
    };

    const getLastLoginDate = date => {
        const tzDate = dateUTCToTimezone(date, timezone);
        const currentTzDate = dateUTCToTimezone(moment.utc(), timezone);
        const isCurrentYear = (tzDate.year() === currentTzDate.year());

        return toDisplayDateTimeString(tzDate, isCurrentYear);
    }

    return <>
        <DataTable.Row className={`${isActive && "active"}`}>
            <DataTable.Cell style={{ width: "40px" }}>{index}</DataTable.Cell>
            <DataTable.Cell>
                {userInfo.role_id === QAPP_ROLE_ID && <i className="fa fa-mobile mr-2" style={{ color: "#087afc" }} />}
                <span>{userInfo.login}</span>
            </DataTable.Cell>
            <DataTable.Cell>{userInfo.role_name}</DataTable.Cell>
            <DataTable.Cell>{userInfo.first_name}</DataTable.Cell>
            <DataTable.Cell>{userInfo.last_name}</DataTable.Cell>
            <DataTable.Cell>{userInfo.meta_data}</DataTable.Cell>
            <DataTable.Cell style={{ textAlign: "center" }}>{getStatus()}</DataTable.Cell>
            <DataTable.Cell>{userInfo.last_login_date ? getLastLoginDate(userInfo.last_login_date) : null}</DataTable.Cell>
            {isAllowAction && <DataTable.Cell >
                <div className="m-0 px-1 d-flex">
                    {isAllowEdit && userInfo.role_id !== QAPP_ROLE_ID &&
                        <div className='ml-2'>
                            <Button disabled={userInfo && userInfo.status_id && userInfo.status_id !== 1} variant='primary' className="mr-2" size='sm' style={{ width: "100px" }}
                                onClick={() => handleModal("assignFarm", true)}>Assign farm</Button>
                        </div>
                    }
                    {isAllowEdit && isCustomerList && <div className='ml-2'> <Button variant='primary' className="mr-2" size='sm' style={{ width: "130px" }}
                        onClick={() => handleModal("assignCustomer", true)}>Assign Customer</Button></div>
                    }
                    {isAllowEdit && <div className="btn-icon p-0 ml-2">
                        <Icon className="fa fa-pencil" title="Edit" id={userInfo.user_id}
                            onClick={() => handleModal("edit", true)}></Icon>
                    </div>}
                    {isAllowDelete && <div className="btn-icon p-0 ml-2">
                        <Icon className="fa fa-trash" title="Delete" id={userInfo.user_id}
                            onClick={() => handleModal("delete", true)}></Icon>
                    </div>}
                </div>
            </DataTable.Cell>}
            {isAllowAction && <DataTable.Cell >
                <div className="m-0 px-1 d-flex">
                    {isAllowEdit && userInfo.role_id !== QAPP_ROLE_ID &&
                        <div className='ml-2'>
                            <Button disabled={userInfo && userInfo.status_id && userInfo.status_id !== 1} variant='primary' className="mr-2" size='sm' style={{ width: "100px" }}
                                onClick={() => handleModal("assignOEM", true)}>Assign OEM</Button>
                        </div>
                    }
                </div>
            </DataTable.Cell>}
            {isRequestingAuthList
                ? <DataTable.Cell style={{ textAlign: "center" }}>
                    <LoadingStyle />
                </DataTable.Cell>
                : <DataTable.Cell className="access-tab"
                    style={{
                        "--count": `${userInfo.authList && userInfo.authList.length > 0 ? userInfo.authList.length - 1 : 0}px`
                    }}>
                    <>
                        <span className="btn-icon float-right mr-1">
                            <Icon className="fa fa-ellipsis-h" title="Access" id={userInfo.user_id}
                                onClick={() => handleModal("access", true)}></Icon>
                        </span>
                        {userInfo.authList && getSortedAuthList(userInfo.authList).map(item => {
                            const iconName = providerListById[item.authentication_provider_id].authentication_provider_name.toLowerCase();
                            const authIconUrl = require(`../../../../assets/images/auth_${iconName}.png`);
                            return <span key={item.authentication_provider_id} className="btn-icon access-img">
                                <img src={authIconUrl} alt="" height="17px" width="17px"
                                    onClick={() => handleAccessModal("access", true, item.authentication_provider_id)} />
                            </span>
                        })}
                    </>
                </DataTable.Cell>}
            <DataTable.Cell className="center">
                <span className="btn-icon">
                    <Icon className="fa fa-unlock-alt" title="Permission" id={userInfo.user_id}
                        onClick={() => handleModal("permission", true)}></Icon>
                </span>
            </DataTable.Cell>
        </DataTable.Row>
        {showModal.edit && <UserForm userId={userInfo.user_id} onHide={() => handleModal("edit", false)} />}
        {showModal.assignFarm && <AssignFarmModal userId={userInfo.user_id} onHide={() => handleModal("assignFarm", false)} />}
        {showModal.assignCustomer && <AssignCustomerModal userId={userInfo.user_id} onHide={() => handleModal("assignCustomer", false)} />}
        {showModal.assignOEM && <AssignOEMModal userId={userInfo.user_id} onHide={() => handleModal("assignOEM", false)} />}
        {showModal.delete && <Modal.Confirm
            isOpen={true}
            onConfirm={handleDeleteConfim}
            iconClassName="fa fa-trash"
            body={`Do you really want to delete these ${userInfo.login}?`}
            onHide={() => handleModal("delete", false)} />}
        {showModal.access && <AccessFormModal
            userId={userInfo.user_id}
            currentAuthId={currentAuthId}
            providerListById={providerListById}
            onHide={() => handleAccessModal("access", false, null)} />}
        {showModal.permission && <PermissionFormModal
            userId={userInfo.user_id}
            onHide={() => handleModal("permission", false)} />}
    </>
}

const mapStateToProps = (state, ownProps) => ({
    providerListById: state.users.authProviderListById.payload,
    userInfo: state.users.userListById.payload[ownProps.userId],
    isRequestingAuthList: state.users.userListById.isRequestingAuthList,
    timezone: state.farm.currentFarm.timezone_identifier
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({ deleteUser }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(UserItem);